<template>
  <div class="box-all">
    <h4 class="w-100 text-right">תקנון שימוש באתר</h4>
    <ol class="w-100">
      <li>אתר זה בבעלות חברת ב.ל סברס שיווק בע"מ (להלן: <span>"החברה"</span> ).</li>
      <li>השימוש באתר זה ובמוצרים המפורסמים בו מותנה בהסכמת הגולשים באתר לאמור בסעיפים הבאים (להלן: <span>"התקנון"</span> ).
      </li>
      <li>השימוש באתר מותר לבעלי כרטיס אשראי ישראלי שאינם קטינים.</li>
      <li>השימוש באתר ניתן כשירות לציבור.</li>
      <li>השימוש באתר ייעשה בתום לב. </li>
      <li>החברה שומרת לעצמה את הזכות לשנות את התקנון מעת לעת. תקנון לא ישתנה במהלך ביצוע עסקה.</li>
    <h5 class="w-100 text-right">רכישת מוצרים באתר</h5>
      <li>קבלת מוצרים ברכישה דרך האתר מותנית באישור סופי של חברת האשראי שבאמצעותה בוצעה העסקה.</li>
      <li>החברה היא הבעלים הבלעדי של האתר, והיא מוסמכת לקבוע את מחירי המוצרים באתר ואת אופן ותדירות הצגתם.
      </li>
      <li>כל המוצרים המוצעים באתר חדשים, ויימסרו באריזותיהם המקוריות.</li>
      <li>התמונות באתר להמחשה בלבד, ואינן מחייבות את החברה. הפרטים הטכניים המפורטים באתר, לרבות הטמפרטורות, משך זמן החימום וכיו"ב, מבוססים על נתוני היצרן כפי שפורסמו או נמסרו לחברה.  </li>
      <li>הרוכשים באתר יידרשו למסור פרטים מזהים אודות עצמם, כמקובל ברכישות מקוונות (להלן: <span>"הפרטים המזהים"</span> ).
      </li>
      <li>חובת הרוכשים באתר להזין בעת רכישה פרטים מזהים מדויקים ומהימנים.</li>
      <li>ביצוע רכישה באתר מותנה במסירת הפרטים המזהים. ללא הזנתם לא תתאפשר הרכישה.</li>
      <li>הפרטים המזהים שנמסרו למערכת האתר בעת הרכישה יהוו ראיה לאמור בהם.</li>
      <li>עם אישור ושליחת הפרטים המזהים למערכת האתר, לרבות פרטי האשראי, הושלמה הרכישה באתר, ותחול עליה מדיניות
        הביטולים והמשלוחים כאמור להלן.</li>
      <li>החברה אינה נושאת באחריות לרכישות שהשתבשו מסיבות שאינן תלויות בה, כגון הפסקות חשמל, תקלות תקשורת
        וכיו"ב. החברה עומדת לרשות הרוכשים בכל מקרה תקלה. </li>
    <h5 class="w-100 text-right">משלוח המוצרים</h5>
      <li>משלוח המוצר הנרכש מותנה באישור סופי מחברת האשראי על ביצוע העסקה. המשלוח ייצא לדרכו לאחר אישור חברת
        האשראי.</li>
      <li>המוצרים יישלחו לכתובת שמסר הרוכש באתר, באמצעות שליח ובהתאם להחלטת החברה. המוצרים יימסרו עד 14 ימי
        עסקים מיום קבלת האישור מחברת האשראי. </li>
      <li>האתר מבצע משלוחים לכל רחבי הארץ באמצעות חברת שליחויות חיצונית. במקרה של אזורים בעלי גישה מוגבלת,
        תיצור החברה קשר עם המזמין ןתתאם איתו נקודת משלוח חלופית. בפני הלקוח עומדת אפשרות של איסוף עצמי בתיאום
        אישי עם החברה ובכפוף להסכמתה.</li>
      <li>החברה תפעל ככל שלאל ידה לספק את המוצר הנרכש במהירות המירבית. עם זאת, יתכנו עיכובים במסירת המוצרים
        לידי הלקוחות, מסיבות שאינן תלויות בחברה (לרבות בשל תקלות בחברת השליחויות). החברה לא תישא באחריות בגין
        איחור באספקת המוצרים מסיבות אלו.</li>
      <li>אין בהוראות תקנון זה כדי לגרוע מהוראות חוק הגנת הצרכן, תשמ"א-1981.</li>
    <h5 class="w-100 text-right">ביטול</h5>
      <li>לקוח רשאי לבטל את רכישתו בהתאם לתנאים הקבועים בתקנות הגנת הצרכן (ביטול עסקה), תשע"א-2010, ולפי
        התנאים המפורטים להלן.</li>
      <li>הלקוח רשאי לבטל את הרכישה אף לאחר ביצוע החיוב מול חברת האשראי, וזאת תוך 14 יום מיום קבלת המוצר
        לכתובת המשלוח, ובכפוף לתנאים הבאים: <span>1. מתן הודעה בכתב מטעם הרוכש על בקשתו לבטל העסקה; 2. השבת המוצרים
        הנרכשים, באריזתם המקורית, לחברה; 3. השבת המוצרים מבלי שנפגמו המוצר ו\או האריזה; 4. השבת המוצרים מבלי
        שנעשה במוצר ו\או באריזה כל שימוש.</span></li>
      <li>במקרה של ביטול עסקה, החברה רשאית לגבות מהלקוח דמי ביטול בשיעור של 5% ממחיר המוצר או 100 שקלים חדשים
        לפי הנמוך מביניהם, בהתאם להוראות החוק.</li>
      <li>למען הסר ספק, באחריות המבטל להשיב את המוצר בהתאם להוראות סעיף 23 לעיל, על חשבונו, לכתובת שתימסר לו
        על ידי החברה. </li>
      <li>החברה שומרת לעצמה את הזכות לבטל עסקאות במצבים חריגים, דוגמת תקלות טכניות חמורות, תקלות תקשורת, תקלות
        אשראי, תקלות של חברת השליחויות וכיו"ב. </li>
      <li>במקרה של טעות בהקלדת הפרטים המזהים, החברה לא תישא באחריות כלשהי במישרין או בעקיפין. החברה לא תישא
        באחריות כלשהי, במקרה שפרטי הקנייה לא אושרו בשל תקלה טכנית המונעת את ביצוע הפעולות באתר.</li>
    <h5 class="w-100 text-right">אחריות</h5>
      <li>כל הרוכש באתר מסכים בזאת כי האחריות להרכבת המוצרים הנרכשים ולהתקנתם של מוצרים אלה, תחול עליו ועל
        חשבונו הבלעדי. החברה אחראית על אספקת המוצרים הנרכשים בלבד, ואין לה כל אחריות בנוגע להתקנתם ו\או
        להרכבתם ו\או לשימוש בהם. </li>
        <li>החברה מספקת את מבער הגז עם וסת גז אופציונלי בלבד. אין לחברה כל אחריות להתאמת הווסת למיכלי הגז הספציפיים של הרוכש. 
</li>
      <li>חיבור המוצר הנרכש לגז, אם נדרש חיבור כזה, ייעשה על ידי טכנאי גז מוסמך. לא תהיה לרוכש המוצר באתר כל
        דרישה ו/או טענה כנגד החברה או מי מטעמה בנוגע לחיבור המוצר לגז.</li>
      <li>מודגש בזאת כי התקנת מוצר אשר כולל שימוש בגז, תיעשה באחריות הרוכש בלבד, ובהתאם להוראות כל דין. על
        הרוכש, ככל שיידרש לכך, להתקין את המוצר הנרכש בהתאם לאמור בסעיף 1 לצו הפיקוח על מצרכים ושירותים (שירות
        אספקת גז), תשל"ו-1976, בהתאם לדרישות ת"י 158 למערכות גפ"מ ובהתאם לחוק הגז (בטיחות ורישוי), תשמ"ט-1989,
        חוק הפיקוח על מצרכים ושירותים, תשי"ח-1957 ,צו הפיקוח על מצרכים ושירותים (הבטחת ההספקה של גפ"מ),
        תשמ"ט-1989 וצו הפיקוח על מצרכים ושירותים (שירות אספקת גז), תשל"ו-1976. </li>
      <li>הרוכש יהיה אחראי באופן בלעדי לתחזוקתו של כל מוצר אשר נרכש על ידו באתר, והשימוש בו יהא על אחריותו
        בלבד, באופן סביר ובתום לב, בהתאם להוראות המוצר ולכל דין.</li>
      <li>החברה לא תישא באחריות כלשהי, במישרין או בעקיפין, לנזק אשר ייגרם בשל מעשה או מחדל של רוכש המוצר או מי
        מטעמו, בעת השימוש במוצר או לאחריו. בפרט לא בשל שימוש בניגוד להוראות המוצר.</li>
      <li>החברה היא היבואן של המוצרים המשווקים באתר. למיטב ידיעת החברה, כל המוצרים המשווקים באתר יוצרו בתנאים
        נאותים, ונארזו כשהם תקינים וראויים לשימוש. </li>
    <h5 class="w-100 text-right">אבטחת מידע והגנת הפרטיות</h5>
      <li>אבטחת המידע באתר נעשית בהתאם לכללי אבטחת המידע המקובלים ובהתאם לנדרש על פי דין.</li>
      <li>האתר רשאי לשלוח לרוכשים שהשלימו את הליך הקנייה דואר אלקטרוני או מסרון שמאשר את קנייתם. </li>
      <li>החברה לא תספק, בשום מקרה, מידע אישי שקשור לפרטים המזהים לצד שלישי, למעט מקרים הכרחיים שנדרשים להשלמת
        העסקה או בהתאם לכל דרישה חוקית. </li>
      <li>לצורך אבטחת האתר ואבטחת המידע, האתר עשוי לאסוף ולנתח את כתובות ה-IP של הגולשים בו. הכל כמקובל בתחום.
      </li>
      <li>COOKIES: בזמן הגלישה באתר, שומר שרת האתר קבצי טקסט שמכונים COOKIES. קבצים אלה מסייעים לשיפור
        השירותים הניתנים באתר. השימוש בקבצים אלה אוטומטי ונדרש לתהליך הרכישה, כמקובל בתחום. </li>
      <li>השימוש בפרטי אמצעי התשלום של הרוכשים באתר נעשה לשם ביצוע התשלום בלבד. פרטים אלה אינם מועברים לשום
        גורם אחר, למעט גורמים הנדרשים לשם ביצוע התשלום, דוגמת חברת האשראי או הבנק. פרטי כרטיס האשראי <span>מוזנים
        באופן ישיר לאתר חברת הסליקה</span> ולא נשמרים במערכת האתר. </li>
      <li>החברה לא תישא באחריות לכל פעילות בלתי חוקית שנעשית על ידי המבקרים באתר או על ידי גורם אחר.</li>
      <li>פנייה אקטיבית של אדם אל החברה באמצעות אפליקציות וואטספ או מסנג'ר, מהווה הסכמה לקבלת מענה ועדכונים מהחברה באמצעות אפליקציות אלה.</li>
    <h5 class="w-100 text-right">קניין רוחני</h5>
      <li>החברה היא בעלת זכויות היוצרים והקניין הרוחני באתר לרבות המדיה ו\או הקבצים ו\או התמונות ו\או הסמלים
        המופיעים בו. </li>
      <li>אין להעתיק ו/או לשכפל ו/או להפיץ ו/או לפרסם ו/או לשלוח את תכני האתר כולם או מקצתם. כל פעולה בעניין
        זה ללא הסכמה מפורשת מראש ובכתב של החברה, תהווה פגיעה בקניינה הרוחני.</li>
    <h5 class="w-100 text-right">שונות</h5>
      <li>גולשי האתר ו\או הרוכשים את המוצרים המשווקים בו, מאשרים כי קראו והבינו תקנון זה, ומסכימים לכל האמור
        בו. </li>
    </ol>
    <h5 class="w-100 text-right">תחולת הדין וסמכות שיפוט ייחודית</h5>
    <ul class="w-100">
      <li>הדין החל על תקנון זה הנו דין מדינת ישראל והוא בלבד, סמכות השיפוט הייחודית והבלעדית לעניין תקנון זה
        נתונה אך ורק לבתי המשפט המוסמכים</li>
    </ul>

  </div>
</template>

<script>
  // @ is an alias to /src
  // import OnNapoli from '@/components/OnNapoli.vue'
  // import Swal from 'sweetalert2'


  export default {
    name: 'Regulations',
    components: {},
    data() {
      return {
        // showModal: false,
      }
    },


  }
</script>

<style scoped>
  span {
    font-weight: bold;
  }

  .box-all {
    width: 70%;
  }

  h5 {
     text-decoration: underline;
     margin-top: 10px;
  }

  @media (max-width: 767.98px) {
    .box-all {
    width: 100%;
  }
  }
</style>